__turbopack_context__.v({
  "Streamdown": "InAppAgentMessage-module__qJS5ra__Streamdown",
  "compact": "InAppAgentMessage-module__qJS5ra__compact",
  "dark": "InAppAgentMessage-module__qJS5ra__dark",
  "prose": "InAppAgentMessage-module__qJS5ra__prose",
  "prose-sm": "InAppAgentMessage-module__qJS5ra__prose-sm",
  "thinking-shimmer": "InAppAgentMessage-module__qJS5ra__thinking-shimmer",
  "thinkingShimmer": "InAppAgentMessage-module__qJS5ra__thinkingShimmer",
});
